var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.formData.title,
            visible: _vm.drawer,
            direction: _vm.direction,
            modal: true,
            "append-to-body": true,
            "wrapper-closable": true,
            "before-close": _vm.handleClose,
            size: _vm.formData.width,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "invoice-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("el-row", { staticClass: "invoice-header" }, [
                _c("div", { staticClass: "invoice-left" }, [
                  _c("img", {
                    staticClass: "img",
                    attrs: {
                      src: _vm.list.card ? _vm.list.card.avatar : "",
                      alt: "",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "invoice-right" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(
                      _vm._s(_vm.list.card ? _vm.list.card.name : "--") +
                        "的合同付款申请"
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.list.status === 0
                    ? _c("span", { staticClass: "text color1" }, [
                        _vm._v(" 待审核 "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.list.status === 1
                    ? _c("span", { staticClass: "text color2" }, [
                        _vm._v(" 已通过 "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.list.status === 2
                    ? _c("span", { staticClass: "text color3" }, [
                        _vm._v(" 未通过 "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.list.status === -1
                    ? _c("span", { staticClass: "text color2" }, [
                        _vm._v(" 已撤回 "),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("el-form", { attrs: { "label-width": "100px" } }, [
                _c("div", { staticClass: "from-item-title mb15" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.list.bill_types == 0 ? "支出信息" : "付款信息")
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-box" }, [
                  _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.list.types == 2 ? "支出时间：" : "付款时间：",
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.list.date))])]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.list.types == 2
                                ? "支出金额(元)："
                                : "付款金额(元)：",
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.list.num))])]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("el-form-item", { attrs: { label: "支付方式：" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.list.pay_type))]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.list.types == 2 ? "支出单号：" : "付款单号：",
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.list.bill_no || "--"))])]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.list.types == 2 ? "支出凭证：" : "付款凭证：",
                          },
                        },
                        [
                          JSON.stringify(_vm.list.attachs) == "[]"
                            ? _c("span", [_vm._v("--")])
                            : _c("img", {
                                staticClass: "img",
                                attrs: {
                                  src: _vm.list.attachs
                                    ? _vm.list.attachs[0].src
                                    : "",
                                  alt: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.lookViewer(
                                      _vm.list.attachs[0].src,
                                      ""
                                    )
                                  },
                                },
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "line" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "from-item-title mb15" }, [
                    _c("span", [_vm._v("其他信息")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("el-form-item", { attrs: { label: "客户名称：" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.list.client ? _vm.list.client.name : "--"
                            )
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("el-form-item", { attrs: { label: "合同名称：" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.list.treaty
                                ? _vm.list.treaty.contract_name
                                : "--"
                            )
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.list.types !== 2
                    ? _c(
                        "div",
                        { staticClass: "form-item" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "业务类型：" } },
                            [
                              _vm.list.types === 0
                                ? _c("span", [_vm._v("合同回款")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.list.types === 1
                                ? _c("span", [
                                    _vm._v(
                                      "合同续费 - " +
                                        _vm._s(_vm.list.renew.title)
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.list.types === 1 && _vm.list.types !== 2
                    ? _c(
                        "div",
                        { staticClass: "form-item" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "续费结束日期：" } },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.list.end_date == "0000-00-00"
                                      ? "--"
                                      : _vm.list.end_date
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.list.types !== 2
                    ? _c(
                        "div",
                        { staticClass: "form-item" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "发票审核状态：" } },
                            [
                              _vm.list.invoice
                                ? [
                                    _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getInvoiceStatus(
                                              _vm.list.invoice.status
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                : _c("span", [_vm._v("--")]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("el-form-item", { attrs: { label: "备注：" } }, [
                        _c("span", { staticClass: "lh24" }, [
                          _vm._v(_vm._s(_vm.list.mark || "--")),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.list.status === 0 && _vm.formData.type !== 1
            ? _c(
                "div",
                { staticClass: "button from-foot-btn fix btn-shadow" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.handleContract },
                    },
                    [_vm._v("通过")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "danger" },
                      on: { click: _vm.refuse },
                    },
                    [_vm._v("拒绝")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("expend-dialog", {
        ref: "expendDialog",
        attrs: { config: _vm.operationDialog },
        on: { isOk: _vm.isOk },
      }),
      _vm._v(" "),
      _c("operationDialog", {
        ref: "operationDialog",
        attrs: { statusOption: _vm.statusOptions, config: _vm.operationDialog },
        on: { isOk: _vm.isOk },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            top: "25vh",
            "append-to-body": true,
            visible: _vm.dialogVisible,
            width: "540px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "from",
              staticClass: "from",
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.reason + "：",
                    "label-width": "90px",
                    prop: "remarks",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small" },
                      on: { click: _vm.cancelFn },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.submitFn },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("image-viewer", {
        ref: "imageViewer",
        attrs: { "src-list": _vm.srcList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }